import {useNavigate} from 'react-router-dom';
import {getSplashConfig, getStepId} from '../utils/stepsConfig';
import {useFunnel} from "../context/FunnelContext";

export function useFunnelNavigation() {
    const {state, dispatch} = useFunnel();
    const navigate = useNavigate();

    const nextStep = () => {
        // If we're currently on a splash screen
        if (typeof state.currentStep === "string" && state.currentStep.startsWith("splash_")) {
            const targetStep = parseInt(state.currentStep.split("_")[1]);
            dispatch({
                type: "SET_STEP",
                payload: targetStep,
            });
            navigate(`/step/${getStepId(targetStep)}`);
            return;
        }

        // Check if next step has a splash screen
        const nextStep = state.currentStep + 1;
        const nextSplashConfig = getSplashConfig(nextStep);

        if (nextSplashConfig) {
            const splashStep = `splash_${nextStep}`;
            dispatch({
                type: "SET_STEP",
                payload: splashStep,
            });
            // Navigate to the splash screen URL
            navigate(`/step/${getStepId(splashStep)}`);
            return;
        }

        // Regular step navigation
        dispatch({
            type: "SET_STEP",
            payload: nextStep,
        });
        navigate(`/step/${getStepId(nextStep)}`);
    };

    const previousStep = () => {
        const prevStep = state.currentStep - 1;
        dispatch({
            type: "SET_STEP",
            payload: prevStep,
        });
        navigate(`/step/${getStepId(prevStep)}`);
    };

    return {nextStep, previousStep, currentStep: state.currentStep};
}